import store from '../store';

const log = (text = '', complement) => {
  console.log(text, complement || (window.location.pathname + window.location.search));
}

export const trackGaEvent = (eventName) => {
  const subscription = store.getState().subscription;

  let data = {
    event: eventName,
    ecommerce: {
      currency: 'BRL',
      value: subscription.totalPrice,
      coupon: subscription.voucher,
      shipping: subscription.shippingPrice,
      items: [{
        item_id: 'subscription_coffee',
        item_name: 'Café de assinatura',
        item_category: 'Cafés',
        item_variant: subscription.ground === 'true' ? 'Moído' : 'Em grãos',
        price: 47.8,
        quantity: subscription.quantity
      }]
    }
  }

  if(process.env.REACT_APP_ENV === 'production'){
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(data);
  }
  else {
    log('dataLayer', data);
  }
}

export const trackIdentify = () => {
  const subscription = store.getState().subscription;

  if(subscription.email){
    const data = {
      email: subscription.email,
      name: subscription.name,
      data: {
        cpf: subscription.cpf,
        telefone: subscription.cellphone,
      }
    }

    log('Identify', data);

    if(process.env.REACT_APP_ENV === 'production'){
      data.id = window.dito.generateID(subscription.email);
      
      window.dito.identify(data);
    }
  }
}

export const trackPageView = () => {
  log('PageView');

  trackIdentify();

  if(process.env.REACT_APP_ENV === 'production'){
    window.woopra.track();

    const ditoAction = {
      '/assinar': 'acessou-assinar',
      '/assinar/inicio': 'acessou-assinar',
      '/assinar/perfil': 'acessou-assinar-perfil',
      '/assinar/plano': 'acessou-assinar-plano',
      '/assinar/quantidade-personalizada': 'acessou-assinar-quantidade-personalizada',
      '/assinar/personalizar': 'acessou-assinar-escolher-cafes',
      '/assinar/frequencia': 'acessou-assinar-frequencia',
      '/assinar/frequencia-personalizada': 'acessou-assinar-frequencia-personalizada',
      '/assinar/metodo-de-preparo': 'acessou-assinar-metodo-de-preparo',
      '/assinar/entrega': 'acessou-assinar-entrega',
      '/assinar/pagamento': 'acessou-assinar-pagamento',
    }[stripTrailingSlash(window.location.pathname)]

    if(ditoAction) window.dito.track({ action: ditoAction });
  }
}

export const trackCart = () => {
  log('Cart');

  if(process.env.REACT_APP_ENV === 'production'){
    // window.gtag('event', 'page_view', {
    //   send_to: `${process.env.REACT_APP_GTAG_ID}/${process.env.REACT_APP_GTAG_LABEL}`,
    //   ecomm_pagetype: 'cart',
    //   ecomm_prodid: 'assinatura',
    //   ecomm_totalvalue: '47.8',
    //   ecomm_category: 'New User',
    //   aw_remarketing_only: true
    // });
  }
}

export const trackAddtoCart = () => {
  log('AddToCart');

  if(process.env.REACT_APP_ENV === 'production'){
    trackGaEvent('add_to_cart');
  }
}

export const trackRemoveFromCart = () => {
  log('RemoveFromCart');

  if(process.env.REACT_APP_ENV === 'production'){
    trackGaEvent('remove_from_cart');
  }
}

export const stripTrailingSlash = (str) => {
  return str.replace(/\/\/*/g,"/").replace(/\/+$/,"");
}